import {
  convertStore,
  Id,
  StoresResponse as Response,
  StoreData,
} from '@nextforce/api'
import { useQuery } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useStore(storeId: Id | undefined) {
  const { server } = useServer()
  return useQuery<StoreData>({
    queryKey: storeId ? keys.details(storeId) : [],
    queryFn: fetchStoreDetails,
  })

  async function fetchStoreDetails() {
    if (!storeId) {
      throw new Error('Illegal store ID')
    }

    const response = await server.get<Response.Store>(
      `/v2/managers/me/stores/${storeId}`
    )

    return convertStore(response)
  }
}
